function getDefaultConfig() {
  // console.log('NODE_ENV:', process.env.NODE_ENV);
  // console.log('REACT_APP_API_PATH:', process.env.REACT_APP_API_PATH);

  return process.env.REACT_APP_API_PATH || "https://development.tms.api.bjshomedelivery.com";
}

function getBaseEndpoint() {
  return getDefaultConfig();
}

export default getBaseEndpoint;
